import Button from '../Button';
import { allNumbers } from '../../utils/utils';
import React from 'react';
import "./Numbers.css";

const renderNumbers = (text, id, onClickNumber) => {
    return (
        <React.Fragment key={`${text}-${id}`}>
            <Button 
                id={id} classes="numbers" 
                data-testid="numbers" text={text} 
                onClickHandler={()=> onClickNumber(text)}
            />
        </React.Fragment>
    );
}

const Numbers = ({ onClickNumber }) => {
    return(
      <div className="numbers">
        { 
          allNumbers.map( item => renderNumbers(item.text, item.id, onClickNumber) )
        }
      </div>
    );
}

export default Numbers;